// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hs-z","tooltipWrapper":"is-z","icon":"js-z","tooltip":"ks-z","content":"ls-z"};